<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (currentContent === 'documents') {
      <div class="card">
        <h4 class="card-header">
          Documents
        </h4>
        <div class="card-body">
          <p>Page containing useful documents and guidelines for the team, sorted by title.</p>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th>
                  <div class="row">
                    <div class="form-group col-md-4 mb-md-0">
                      <input class="form-control" type="text" [(ngModel)]="titleFilter" placeholder="Filter by title">
                    </div>
                    <div class="form-group col-md-4 mb-0">
                      <select class="form-control" [(ngModel)]="departmentFilter">
                        <option value="" selected>Filter by department</option>
                        @for (department of guidelineDepartments; track department) {
                          <option [value]="department">{{department}}</option>
                        }
                      </select>
                    </div>
                    <div class="form-group col-md-1 mb-0">
                      <app-spinner [condition]="isLoading"></app-spinner>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (guideline of guidelines | filter:'title':titleFilter | filter:'department':departmentFilter; track guideline) {
                <tr>
                  <td>
                    <a [href]="guideline.url" target="_blank">{{guideline.title}}</a>
                    @if (guideline.pinned) {
                      <i class="fa fa-thumb-tack ms-2 text-primary rotate45"></i>
                    }
                    <span class="text-muted small ms-2">({{guideline.url.split('/')?.[2]}})</span>
                    <br>
                      <span class="small">{{guideline.department}}</span>
                      <span class="float-end">
                        <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-guideline-modal" (click)="toggleEditGuidelineModal(guideline)">
                          <i class="fa fa-pencil"></i> Edit
                        </button>
                        @if (auth.isAdmin || canEditGuideline) {
                          <app-delete-btn (click)="deleteGuideline(guideline)" size="xs"></app-delete-btn>
                        }
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      @if (currentContent === 'add-new-document' && !guidelineAdded) {
        <div class="card">
          <h4 class="card-header">
            Documents &raquo; Add new
          </h4>
          <div class="card-body">
            <app-add-guideline-form></app-add-guideline-form>
          </div>
        </div>
      }
      @if (currentContent === 'add-new-document' && guidelineAdded) {
        <div class="card">
          <h4 class="card-header">
            Add new document
          </h4>
          <div class="card-body">
            <p>
              Document added successfully!
            </p>
            <a class="nav-link" [routerLink]="" (click)="currentContent = 'documents'; guidelineAdded = false">
              <i class="fa fa-book"></i> Go to documents page
            </a>
            <a class="nav-link" [routerLink]="" (click)="guidelineAdded = false">
              <i class="fa fa-plus-circle"></i> Add another document
            </a>
          </div>
        </div>
      }
    </div>
  </div>

  @if (isEditGuidelineModalVisible) {
    <app-edit-guideline-modal [guideline]="guideline" [field]="field"></app-edit-guideline-modal>
  }